import MyProfile from './my-profile';

export default MyProfile;
